// src/components/pwa/UpdateToast.tsx
import React from 'react';
import { Button, Icon, IconButton } from '../common';
import { usePWA } from '../../contexts/pwa-hooks';

/**
 * Persistent bottom-right toast notification when a new Service Worker is waiting.
 * Reappears on page reload if dismissed (not permanent).
 */
export const UpdateToast: React.FC = () => {
    const { needsUpdate, updateApp, dismissUpdate } = usePWA();

    if (!needsUpdate) return null;

    return (
        <div
            id="pwa-update-toast"
            className="fixed bottom-4 right-4 z-50 flex items-center gap-3 px-4 py-3 rounded-xl
                bg-gray-900 dark:bg-gray-800 text-white shadow-2xl border border-amber-500/40
                animate-slide-in-right max-w-sm"
        >
            <Icon name="system_update" className="text-amber-400 text-xl shrink-0" />
            <div className="flex-1 min-w-0">
                <p className="text-sm font-medium">A new version is available</p>
            </div>
            <Button
                variant="primary"
                size="sm"
                onClick={updateApp}
                className="min-h-0 shrink-0 px-3 py-1.5 text-xs font-bold uppercase tracking-wide
                    bg-amber-500 text-gray-900 shadow-none hover:bg-amber-400"
            >
                Update Now
            </Button>
            <IconButton
                icon="close"
                label="Dismiss update notification"
                onClick={dismissUpdate}
                className="flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-full text-white hover:bg-white/10 hover:text-white"
            />
        </div>
    );
};
